export default __webpack_public_path__ + "static/media/000_wurz.1dcc8819.avif";